// extracted by mini-css-extract-plugin
export default {"container":"Admissions_page_container__XT2FW","mainTitle":"Admissions_page_mainTitle__Rtmeb"};